import TabapaySuccessScreen from 'features/moveMoney/screens/dcf/tabapay/TabapaySuccess/TabapaySuccessScreen';
import React from 'react';

export default function TabapaySuccessPage() {
  return <TabapaySuccessScreen />;
}
